import React, { ChangeEvent, useState, useEffect } from 'react';
import { makeStyles, Typography, Grid, Button, Theme, Hidden, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import LocalVideoPreview from './LocalVideoPreview/LocalVideoPreview';
import SettingsMenu from './SettingsMenu/SettingsMenu';
import { Steps } from '../PreJoinScreens';
import ToggleAudioButton from '../../Buttons/ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from '../../Buttons/ToggleVideoButton/ToggleVideoButton';
import { useAppState } from '../../../state';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { TASK_ID } from '../../../constants';

//import { AnyARecord } from 'dns';

//const AccessToken = require('twilio').jwt.AccessToken;

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  marginTop: {
    marginTop: '1em',
  },
  deviceButton: {
    width: '100%',
    border: '2px solid #aaa',
    margin: '1em 0',
  },
  localPreviewContainer: {
    paddingRight: '2em',
    [theme.breakpoints.down('sm')]: {
      padding: '0 2.5em',
    },
  },
  joinButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      width: '100%',
      '& button': {
        margin: '0.5em 0',
      },
    },
  },
  mobileButtonBar: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '1.5em 0 1em',
    },
  },
  mobileButton: {
    padding: '0.8em 0',
    margin: 0,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  textFieldContainer: {
    width: '100%',
  },
  errorMessage: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    // margin: '1em 0 0.2em',
    '& svg': {
      marginRight: '0.4em',
    },
  },
  input: {
    border: '2px solid #aaa',
    marginBottom: '1em',
  },
  noBorder: {
    border: 'none',
  },
}));

// const DeviceSelectionScreenStaticSiteOptions: string[] = ['Board Round Queue', 'PSO Queue'];

interface DeviceSelectionScreenProps {
  name: string;
  roomName: string;
  email: string;
  phonenumber: string;
  agentCall: boolean;
  setStep: (step: Steps) => void;
  lastName: string;
  patientName: string;
  patientLastName: string;
  patientPhoneNumber: string;
  siteCode: string;
  category: string;
  isStatic: boolean;
}

export default function DeviceSelectionScreen({
  name,
  roomName,
  email,
  phonenumber,
  agentCall,
  setStep,
  lastName,
  patientName,
  patientLastName,
  patientPhoneNumber,
  siteCode,
  category,
  isStatic,
}: DeviceSelectionScreenProps) {
  const classes = useStyles();
  const { getToken, isFetching, setTaskSid } = useAppState();
  const { connect: chatConnect } = useChatContext();
  const { connect: videoConnect, isAcquiringLocalTracks, isConnecting } = useVideoContext();
  const [joinScreenSiteCode, setjoinScreenSiteCode] = useState<string>('');
  const [showSiteCodeField, setShowSiteCodeField] = useState<boolean>(false);
  const [siteCodeError, setSiteCodeError] = useState<string>('');
  const hasSiteFieldHospital = 'Katherine_Hospital';
  const disableButtons = isFetching || isAcquiringLocalTracks || isConnecting;

  useEffect(() => {
    const searchStr = window.sessionStorage.getItem('searchStr');
    if (!!searchStr) {
      const searchParams = new URLSearchParams(searchStr);
      // const agentName = searchParams.get('name');
      const room = searchParams.get('room');
      const isStaticParam = searchParams.get('isStatic');
      if (!!isStaticParam && isStaticParam === 'true' && !!room && room === hasSiteFieldHospital) {
        setShowSiteCodeField(true);
      } else {
        setShowSiteCodeField(false);
      }
    }
  }, []);
  const validateSiteCodeField = () => {
    let isValidate = false;
    if (showSiteCodeField) {
      if (joinScreenSiteCode === hasSiteFieldHospital) {
        isValidate = true;
      } else {
        isValidate = false;
        setSiteCodeError('Invalid site code');
      }
    } else {
      isValidate = true;
    }
    return isValidate;
  };

  const handleJoin = async () => {
    let isValidate = validateSiteCodeField();
    if (isValidate) {
      const searchStr: string = window.location.search || window.sessionStorage.getItem('searchStr') || '';
      const searchParams = new URLSearchParams(searchStr);
      const isTaskCreated = searchParams.get('task');
      const isEscalate = searchParams.get('escalate') || '';
      const isAssignToAgent = searchParams.get('agentSID') || '';
      const linkExpireCode = searchParams.get('code') || '';
      const callSid = searchParams.get('callSid') || '';
      const outCallSid = searchParams.get('outCallSid') || '';

      const { token } = await getToken(name, roomName);

      // Wait for videoConnect to complete and roomSid to be available
      await videoConnect(token);

      // Wait for roomSid to be available in sessionStorage, only use this for once
      let roomSid = sessionStorage.getItem('videoRoomSid');
      sessionStorage.removeItem('videoRoomSid');

      process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && chatConnect(token);

      let workflowSid: any = '';
      if (searchParams.get('workflowId') !== null && searchParams.get('workflowId') !== '') {
        workflowSid = searchParams.get('workflowId');
      }

      if (!agentCall && isTaskCreated === null) {
        var uri = window.location.href;
        var environment = 'prod';
        if (uri.match('-uat')) environment = 'uat';
        if (uri.match('-test')) environment = 'test';
        if (uri.match('localhost')) environment = 'test';

        try {
          const response = await fetch(
            'https://9bar5krn82.execute-api.ap-southeast-2.amazonaws.com/' + environment + '/med-video-website-api',
            {
              headers: {
                'Content-Type': 'application/json',
                'X-API-Key': 'JLNS9E5LhG4SeRf6qHpza4C0wVPgXgJc7v0ICKKN',
              },
              method: 'POST',
              body: JSON.stringify({
                siteCode: siteCode,
                triageCat: category,
                from: phonenumber,
                email: email,
                room: roomName,
                name: `${name} ${lastName}`,
                patientName: `${patientName} ${patientLastName}`,
                phoneNumber: phonenumber,
                patientPhoneNumber: patientPhoneNumber,
                workflowSid: workflowSid,
                code: linkExpireCode,
                agentSID: isAssignToAgent || '',
                escalate: isEscalate || '',
                callSid: callSid || '',
                outCallSid: outCallSid || '',
                roomSid: roomSid,
              }),
            }
          );
          const newTaskId = await response.json();
          window.localStorage.setItem(TASK_ID, newTaskId.TaskId);
          setTaskSid(newTaskId.TaskId);
        } catch (error) {
          console.error('Error creating task:', error);
        }
      }
    }
  };

  const handleCancel = (step: any) => {
    let isEndSession = window.sessionStorage.getItem('endSession'); //

    if (isStatic && isEndSession === 'true') {
      window.sessionStorage.getItem(''); //
      setStep(Steps.callEnded);
    } else if (isStatic && showSiteCodeField) {
      setStep(Steps.callCanceled);
    } else {
      setStep(step);
    }
    window.parent.postMessage({ endCall: true }, '*');
  };

  if (isFetching || isConnecting) {
    return (
      <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
        <div>
          <CircularProgress variant="indeterminate" />
        </div>
        <div>
          <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
            Joining Meeting
          </Typography>
        </div>
      </Grid>
    );
  }
  const handleSiteCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setjoinScreenSiteCode(event.target.value);
    // setCanSubmit(event.target.value.length > 0);
  };
  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Virtual Waiting Room
      </Typography>

      <Grid container justifyContent="center">
        <Grid item md={7} sm={12} xs={12}>
          <div className={classes.localPreviewContainer}>
            <LocalVideoPreview identity={name} />
          </div>
          <div className={classes.mobileButtonBar}>
            <Hidden mdUp>
              <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
              <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} />
            </Hidden>
            <SettingsMenu mobileButtonClass={classes.mobileButton} />
          </div>
        </Grid>
        <Grid item md={5} sm={12} xs={12}>
          <Grid container direction="column" justifyContent="space-between" style={{ height: '100%' }}>
            <div>
              {showSiteCodeField ? (
                <div className={classes.textFieldContainer}>
                  <TextField
                    placeholder="site code"
                    autoCapitalize="false"
                    id="input-site-code"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={joinScreenSiteCode}
                    onChange={handleSiteCodeChange}
                    InputProps={{
                      autoComplete: 'off',
                      className: classes.input,
                      classes: { notchedOutline: classes.noBorder },
                    }}
                  />
                  <div>
                    {siteCodeError && (
                      <Typography variant="caption" className={classes.errorMessage}>
                        <ErrorOutlineIcon />
                        {siteCodeError}
                      </Typography>
                    )}
                  </div>
                </div>
              ) : null}
              <Hidden smDown>
                <ToggleAudioButton className={classes.deviceButton} disabled={disableButtons} />
                <ToggleVideoButton className={classes.deviceButton} disabled={disableButtons} />
              </Hidden>
            </div>
            <div className={classes.joinButtons}>
              <Button variant="outlined" color="primary" onClick={() => handleCancel(Steps.roomNameStep)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                data-cy-join-now
                onClick={handleJoin}
                disabled={disableButtons}
              >
                Join
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
